export default __webpack_public_path__ + "static/media/red_pagos.3a48caae.png";